<template>
  <div class="cwDropdownWrapper" v-show="isVisible">
    <h3 v-show="decoratorLabel">{{ getCactusString(decoratorLabel) }}</h3>
    <cw-dropdown
      class="dropdown-l"
      v-model="selectedData"
      v-bind="dropdownProps"
      :title="cmpConfig.component.decorator.label_static"
      @input="valueChanged"
    ></cw-dropdown>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import cwDropdown from './cwDropdown.vue';
import expertviewMixin from './experviewMixin';

export default {
  name: 'CwDropdownWrapper',
  components: { cwDropdown },
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {},
      required: true
    },
    fwParams: {
      type: Array,
      default: () => [],
      required: true
    },
    valueSet: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      selectedData: undefined,
      rulesValue: []
    };
  },
  created() {
    this.$log.debug('cwDropdownWrapper::created()', this.cmpConfig);

    if (this.ruleSubscriber.length > 0) {
      this.applyRules();
    }

    if (this.ruleProvider.length > 0) {
      const defaultValue = this.cmpConfig.value.default.default;

      if (this.cmpConfig.value.default.fallback_position) {
        // TODO: replace second param with value from backend, not the default one
        const selectedPosition = _findIndex(this.cmpConfig.value.default.values, [
          'value',
          defaultValue
        ]);
        if (selectedPosition > -1) {
          this.applyRuleProvider(defaultValue, selectedPosition);
        } else {
          this.applyRuleProvider(defaultValue, this.cmpConfig.value.default.fallback_position);
        }
      } else {
        this.applyRuleProvider(defaultValue);
      }
    }

    if (this.valueSet.length > 0) {
      this.selectedData = _find(this.valueSet, {
        value: this.valueFromFw.toString()
      });
    } else {
      let defaultSelection = _find((this.listContent || {}).values, {
        value: this.valueFromFw.toString()
      });

      if (!defaultSelection) {
        defaultSelection = _find((this.listContent || {}).values, {
          position: (this.listContent || {}).fallback_position
        });
      }

      this.selectedData = defaultSelection;
    }

    this.valueChanged(this.selectedData);
  },
  computed: {
    ...mapGetters(['latestAppData', 'getRule']),

    decoratorLabel() {
      return ((this.cmpConfig.component || {}).decorator || {}).label_component || '';
    },

    dropdownProps() {
      // if (!this.valueSet && !this.listContent.values) return;
      let optionsArr = this.valueSet.length > 0 ? this.valueSet : (this.listContent || {}).values;

      return {
        value: this.selectedData,
        options: optionsArr || [],
        valueKey: 'value',
        labelKey: 'label'
      };
    },

    listContent() {
      let valKey = 'default';
      if (this.cmpConfig.rule_subscriber && this.valuesWithRules) {
        valKey = this.cmpConfig.rule_subscriber[0].rule[0] || 'default';
      }

      return this.cmpConfig.value[valKey] || this.cmpConfig.value.default;
    },

    listContentValuelist() {
      if (this.cmpConfig.rule_subscriber && this.valuesWithRules) {
        let valKey = this.cmpConfig.rule_subscriber[0].rule[0] || 'default';
        if (this.cmpConfig.value[valKey]) {
          return this.cmpConfig.value[valKey];
        }
      }

      return this.cmpConfig.value.default;
    },

    valuesWithRules: {
      get() {
        return this.rulesValue.map(rule => this.getRule(rule)).every(el => el === true);
      },
      set(newVal) {
        this.rulesValue = newVal;
      }
    },

    valueFromFw() {
      let fwParams = this.getFwApp();
      return this.getAppValue(fwParams.app, fwParams.param) || this.defaultValue;
    }
  },
  methods: {
    ...mapActions(['setRuleProvider']),

    valueChanged(newVal) {
      let fwApp = this.getFwApp();
      this.selectedData = newVal;

      this.applyRuleProvider(newVal.value, newVal.position);

      this.$log.debug('cwDropdownWrapper::valueChanged', {
        app: fwApp.app,
        parameter: fwApp.param,
        value: Number(newVal.value)
      });

      this.setExpertViewParams({
        app: fwApp.app,
        parameter: fwApp.param,
        value: Number(newVal.value)
      });
    },

    handleFallbackPolicy(policy) {
      switch (policy) {
        case 'policy_default':
          // TODO: case if fallback is a position
          return _find(this.cmpConfig.value.default.values, {
            value: this.cmpConfig.value.default.default
          });
        case 'policy_hidden':
          this.isVisible = false;
          return;
        default:
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
h3 {
  @include unitSmall;
  color: $greeny-blue;
  margin: 15px 0 10px 5px;
}
</style>
